import { createReducer, on } from "@ngrx/store";
import { findObjectCatalogAct, loadObjectCatalogByIdAct, resetObjectCatalogAct, saveSuccessObjectCatalogAct, setViolationsObjectCatalogAct, showMsgErrorAct, updateSuccessObjectCatalogAct } from "./object-catalog.action";

const object: Object = new Object();

export const ObjectCatalogReducer = createReducer (
    {
        object,
        violations: {},
        loading: true 
    },
    on(resetObjectCatalogAct, (state) => ({
        object:  { ...object },
        violations: {},
        loading: state.loading
    })),
    on(findObjectCatalogAct, (state, { id }) =>({
        object: { ...object}, 
        violations: state.violations,
        loading: true
    })),
    on(loadObjectCatalogByIdAct, (state, { object }) =>({
        object: { ...object}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessObjectCatalogAct, (state, { objectNew }) => ({
        object: { ...objectNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessObjectCatalogAct, (state, { objectUpdated }) => ({
        object: { ...objectUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsObjectCatalogAct, (state, { objectForm, violations }) => ({
        object: { ...objectForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        object: state.object,
        violations: {},
        loading: false
    }))
)